// extracted by mini-css-extract-plugin
export default {"valueBoxValue":"TodayValue-valueBoxValue-042097ed86d5f19de7820391c9c365e6","valueBoxName":"TodayValue-valueBoxName-9e025092b29fc7503040da5e91f83b99"};